import Service from '../helpers/service';
import { fetchItem, editItem, destroyItem } from "../actions/item_action";
import {
  fetchItemMeta,
  editItemMeta
} from "../actions/item_meta_action";
import Helping from "../helpers/Helping";
import { API_URL } from "../config/urls";
import { GET_NFTS } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}

export const setItemError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type, brandId = "", categoryId = "", typeId = "") => {
  return dispatch => {
    return trackPromise(
      Service.getCall(
        API_URL.ADMIN_TRADING_API + GET_NFTS +
        "?page=" +
        page +
        "&limit=" +
        limit +
        "&search=" +
        search +
        "&sorting=" +
        sorting +
        "&sort_type=" +
        sort_type +
        "&brand_id=" +
        brandId +
        "&category_id=" +
        categoryId +
        "&type_id=" +
        typeId
      )
        .then(response => {
          let total = response.data.payload.total;

          dispatch(fetchItem(response.data.payload.Items));
          dispatch(
            fetchItemMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: total,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);
          dispatch(fetchItem([]));
          dispatch(
            fetchItemMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: 0,
              no_Of_pages: page
            })
          );
          Helping.redirectToLogin(error);
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching nfts")
          })
        })
    )
  };
};

export const update = data => {
  return dispatch => {
    dispatch(editItem(data));
  };
};

export const updateItemsMeta = payload => {
  return dispatch => {
    dispatch(editItemMeta(payload));
  };
};

export const destroy = key => {
  return dispatch => {
    dispatch(fetchItem([]));
    dispatch(
      fetchItemMeta({
        page: 1,
        limit: 10,
        sorting: 'id',
        sort_type: 'desc',
        search: '',
        total: 0,
        no_Of_pages: 0
      })
    );
  }
}

